module.exports = [{"code":1,"name":"抓拍相机"},{"code":2,"name":"车辆闸机"},{"code":3,"name":"行人闸机"},{"code":4,"name":"球机"}]


//////////////////
// WEBPACK FOOTER
// ./static/json/dictionary/deviceType.json
// module id = orNP
// module chunks = 11